import { getSectionProps } from 'utils/styles';
import { CompareProps } from 'libs/contentful/props';
import RichTextTable from 'components/shared/RichTextTable/RichTextTable';

const Compare = ({ sectionName, content, color, margins }: CompareProps) => {
  return (
    <section {...getSectionProps(color, margins, sectionName)}>
      <div className="content-wrapper">
        <RichTextTable content={content} color={color} />
      </div>
    </section>
  );
};
export default Compare;
